import classNames from 'classnames';
import React from 'react';

import {formatNumber, useI18n, I18nApi} from '@udemy/i18n';
import {StarRating} from '@udemy/react-merchandising-components';
import {CourseBuyable} from '@udemy/shopping';

import styles from './shopping-item.module.less';

function getNumRatingsLabel(
    count: number,
    locale: I18nApi['locale'],
    ninterpolate: I18nApi['ninterpolate'],
) {
    return ninterpolate('%(count)s rating', '%(count)s ratings', count, {
        count: formatNumber(count, locale),
    });
}

interface RatingsProps {
    buyable: CourseBuyable;
}

export const Ratings = ({buyable}: RatingsProps) => {
    const {ninterpolate, locale} = useI18n();

    if (!buyable.rating) {
        return null;
    }

    const numRatingsLabel = getNumRatingsLabel(buyable.num_reviews ?? 0, locale, ninterpolate);

    return (
        <div className={classNames(styles.rating)}>
            {!!buyable.rating && (
                <>
                    <StarRating showNumber={true} rating={buyable.rating} />
                    <span
                        className={classNames('ud-text-xs', styles['reviews-text'])}
                        aria-label={numRatingsLabel}
                    >{`(${numRatingsLabel})`}</span>
                </>
            )}
        </div>
    );
};
